export default __webpack_public_path__ + "static/media/benefit_18@3x.2a4fd7c2.png";